module.exports = __webpack_public_path__ + "img/zhangtianfu.b7cd903b.jpg";